import { addToast, Button, Table } from '@octano/global-ui';
import { useRef } from 'react';
import useActions from '../hooks/useActions';
import useColumns from '../hooks/useColumns';
import { useCampusesLoader } from './Loaders/CampusesLoader';
import ConfirmDeleteModal, { ConfirmModalRef } from './Modals/ConfirmModal';
import CreateOrUpdateModal, {
  CreateOrUpdateRef,
} from './Modals/CreateOrUpdateModal';
import { Campus } from '../type';

function CampusesTable() {
  const { data, query, updateQuery, loading, refresh } = useCampusesLoader();
  const actions = useActions({
    onSuccess: (message) => {
      refresh();
      addToast({
        icon: 'success',
        color: 'success',
        text: message,
      });
    },
    onError: (_, message) => {
      addToast({
        icon: 'error',
        color: 'danger',
        text: message ?? 'Ha ocurrido un error',
      });
    },
  });

  const ConfirmModalRef = useRef<ConfirmModalRef | undefined>();
  const createOrUpdateModalRef = useRef<CreateOrUpdateRef | undefined>();

  const onClickEdit = (row: Campus) => {
    createOrUpdateModalRef.current?.openModal(row);
  };
  const onClickRemove = (row: Campus) => {
    ConfirmModalRef.current?.openModal(row);
  };

  const columns = useColumns({ onClickEdit, onClickRemove });

  const handleConfirmDelete = (campusId: number) => {
    actions.deleteCampus(campusId);
  };

  return (
    <>
      <Button
        text="Ingresar Nueva Sede"
        color="primary"
        icon="plus"
        size="md"
        className="mb-3"
        style={{ minWidth: '254px' }}
        onClick={() => createOrUpdateModalRef.current?.openModal()}
      />
      <Table
        columns={columns}
        data={data?.data ?? []}
        isLoadingResults={loading}
        loadingView={{
          title: 'Cargando sedes...',
          subtitle: 'Espere un momento',
        }}
        pagination={{
          currentPage: query?.page ?? 1,
          itemsPerPage: query.itemsPerPage ?? 10,
          totalPages: data?.totalPages ?? 0,
          totalItems: data?.total ?? 0,
          onChangePage: (page) => {
            updateQuery({ ...query, page });
          },
        }}
      />
      <CreateOrUpdateModal
        ref={createOrUpdateModalRef as React.Ref<CreateOrUpdateRef>}
        actions={actions}
      />
      <ConfirmDeleteModal
        onConfirm={(row) => {
          handleConfirmDelete(row.id);
        }}
        ref={ConfirmModalRef as React.Ref<ConfirmModalRef>}
      />
    </>
  );
}

export default CampusesTable;
